module.exports = __webpack_public_path__ + "assets/5f51a0371a2fc4499de370deb483d20a.mp3";